export const PUSH_TAG = '[PUSH]' as const;
